import { Button } from '@mui/joy';

import { useCurrentOrganization } from '@/hooks/useSwr';

import { useSetUpBillingHandlers } from '../PlansAndBillingV2/store/helpers';
import StartupPlanInfoBox from './StartupPlanInfoBox';

export function SetUpBilling({
  isSetupPaymentMutating,
  setupPaymentTrigger,
}: {
  isSetupPaymentMutating?: boolean;
  setupPaymentTrigger?: () => void;
}) {
  const currentOrganization = useCurrentOrganization();

  // this is for v2
  const { handleLegacySetupBilling, isMutating } = useSetUpBillingHandlers();

  return (
    <div className="flex w-[600px] flex-col gap-5 rounded-lg border border-secondary px-9 pb-6 pt-7">
      <div className="flex flex-col gap-3">
        <div className="text-3xl font-semibold leading-loose">
          Set up Billing
        </div>
        <div className="text-md flex flex-col gap-3">
          <div>
            <span className="font-normal leading-tight">
              Set up billing now to avoid hitting usage limits in the future,
              and transition to the{' '}
              <span className="font-bold">
                {currentOrganization.data?.is_personal ? 'Developer' : 'Plus'}
              </span>{' '}
              plan.
            </span>
          </div>
          <div>
            <span className="font-bold leading-tight">Set up billing by:</span>
          </div>
          <div className="flex gap-3">
            <div>💳</div>
            <div>Adding a payment method</div>
          </div>
          <div className="flex gap-3">
            <div>🎁</div>
            <div>
              Claim $250 of free traces as a gift for being an early tester
            </div>
          </div>
        </div>
      </div>
      <StartupPlanInfoBox />
      <div className="self-end">
        <Button
          size="md"
          variant={'solid'}
          color={'primary'}
          loading={isSetupPaymentMutating || isMutating}
          onClick={() => {
            // do v1 or v2 trigger, not both

            if (setupPaymentTrigger) {
              setupPaymentTrigger?.();
              return;
            }
            handleLegacySetupBilling();
          }}
          sx={{ paddingX: 5.5, paddingY: 2 }}
        >
          Set up Billing
        </Button>
      </div>
    </div>
  );
}
